import * as rmd from 'material-ui';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import auth from 'dash-front/auth';

class TemplatePicker extends React.Component {
    static defaultProps = {
        sportId: 1,
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            templates: [],
            templateId: props[props.propKey] || (context.user && context.user.defaultTemplate),
        };
    }

    componentDidMount() {
        this.loadTemplates();
    }

    static contextTypes = {
        user: PropTypes.object.isRequired,
    };

    loadTemplates() {
        const { templateId } = this.state;
        const { user } = this.context;

        return fetch(`/api/templates/list?access_token=${auth.getAccessToken()}`)
            .then(response => response.json())
            .then(templates => {
                let template = templates.find(t => t.id === templateId);
                if (!template) {
                    template = _.first(templates);
                    // fire selection
                    // this.props.onChange(this.props.propKey, template.id);
                    // console.log(this.props.propKey," - to - ", template.id)
                }

                this.setState({
                    templates,
                    templateId: template.id,
                });
            })
            .catch(e => {
                console.error(e);
            });
    }

    handleThemeChange = (e, key, payload) => {
        this.props.onChange(this.props.propKey, payload);
        this.setState({ templateId: payload });
    };

    renderOption(option) {
        return <rmd.MenuItem key={option.value} value={option.value} primaryText={option.text} />;
    }

    render() {
        let { templates, templateId } = this.state;
        templateId = templateId || (templates.find(t => t.isDefault) || {}).id;
        const themesOptions = _.filter(templates, t => !t.isHidden).map(t => ({ text: t.name, value: t.id }));
        return (
            <div>
                {!_.isEmpty(themesOptions) && (
                    <rmd.SelectField
                        style={{ width: '100%' }}
                        floatingLabelText="Template Theme"
                        value={templateId}
                        onChange={this.handleThemeChange}
                    >
                        {themesOptions.map(this.renderOption)}
                    </rmd.SelectField>
                )}
            </div>
        );
    }
}

export default TemplatePicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/TemplatePicker.js
 **/